// Commission creation lives on the native /cp module form (CommissionsModuleExtensions
// compute-on-save + the AboveInfoPanel preview slot), so it needs no custom route.
// Payout is a BATCH (one action → many payouts) which doesn't fit a single-entry module
// form, so it gets a dedicated screen.
export const customRoutes = [
    {
        path: '/payouts/initiate',
        component: require('~/components/Payouts/InitiatePayout.vue').default,
        name: 'initiate-payout',
        meta: {
            onlyIfAuthenticated: true,
            sidebarWidthGroup: 'default',
        },
    },
];
